import Api from '../utils/Api';
import Config from '../config/Config';

class Token {

  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'token' }]);
  }
  
  refres() {
    return this.api.endpoints.token
      .createWithAction('refrescar')
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  };


}

export default new Token;
